module.exports = __webpack_public_path__ + "static/media/winged hat outlined.371d5279.png";